// extracted by mini-css-extract-plugin
module.exports = {"container":"_6f025d","containerWithHeading":"_7c1127","icon":"_0b2ba5","inlineIcon":"_e4dbab","heading":"_4af9b0","content":"_17083b"};